export const MESSAGES_SET = 'at/toasts/MESSAGES_SET'



// WEBPACK FOOTER //
// ./web/js/toasts/actionTypes.js